// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MAMode } from './IndicatorConstants';
import { IAC, iAC } from './indicators/built-in/iAC';
import { IAD, iAD } from './indicators/built-in/iAD';
import { IADX, iADX } from './indicators/built-in/iADX';
import { IADXEx, iADXEx } from './indicators/built-in/iADXEx';
import { IADXEma } from './indicators/built-in/iADXEma';
import { IAlligator, iAlligator } from './indicators/built-in/iAlligator';
import { IAO, iAO } from './indicators/built-in/iAO';
import { IATR, iATR } from './indicators/built-in/iATR';
import { IBands, iBands } from './indicators/built-in/iBands';
import { IBandsEx, iBandsEx } from './indicators/built-in/iBandsEx';
import { IBearsPower, iBearsPower } from './indicators/built-in/iBearsPower';
import { IBullsPower, iBullsPower } from './indicators/built-in/iBullsPower';
import { IBWMFI, iBWMFI } from './indicators/built-in/iBWMFI';
import { ICCI, iCCI } from './indicators/built-in/iCCI';
import { ICCIEx, iCCIEx } from './indicators/built-in/iCCIEx';
import { IDeMarker, iDeMarker } from './indicators/built-in/iDeMarker';
import { IEnvelopes, iEnvelopes } from './indicators/built-in/iEnvelopes';
import { IForce, iForce } from './indicators/built-in/iForce';
import { IFractals, iFractals } from './indicators/built-in/iFractals';
import { IGator, iGator } from './indicators/built-in/iGator';
import { IIchimoku, iIchimoku } from './indicators/built-in/iIchimoku';
import { IMA, iMA } from './indicators/built-in/iMA';
import { IMACD, iMACD, IMACDEx, iMACDEx } from './indicators/built-in/iMACD';
import { IMAEx, iMAEx } from './indicators/built-in/iMAEx';
import { IMom, iMom, IMomEx, iMomEx } from './indicators/built-in/iMom';
import { IMFI, iMFI } from './indicators/built-in/iMFI';
import { IOBV, iOBV } from './indicators/built-in/iOBV';
import { IOsMA, iOsMA } from './indicators/built-in/iOsMA';
import { IRVI, iRVI } from './indicators/built-in/iRVI';
import { ISAR, iSAR } from './indicators/built-in/iSAR';
import { IStdDev, iStdDev } from './indicators/built-in/iStdDev';
import { IStdDevEx, iStdDevEx } from './indicators/built-in/iStdDevEx';
import { ISTO, iSTO } from './indicators/built-in/iSTO';
import { IWPR, iWPR } from './indicators/built-in/iWPR';
import { PriceType } from '@shared/utils/History/CashItemUtils';
class _iBuildInIndicatorFactory {
    CreateIndicator(name, args) {
        switch (name) {
            case iAC:
                return new IAC();
            case iAD:
                return new IAD();
            case iADX: {
                if (args.length === 1) {
                    return new IADX(args[0], MAMode.SMA);
                }
                const mode = args[1];
                return mode === 1 ? new IADXEma(args[0]) : new IADXEx(args[0], PriceType.Close, mode);
            }
            case iADXEx: {
                if (args.length === 2) {
                    return new IADXEx(args[0], args[1], MAMode.SMA);
                }
                const mode = args[2];
                return mode === 1 ? new IADXEma(args[0]) : new IADXEx(args[0], args[1], args[2]);
            }
            case iAlligator:
                return new IAlligator(args[0], args[1], args[2], args[3], args[4], args[5], args[6], args[7]);
            case iAO:
                return new IAO();
            case iATR:
                return new IATR(args[0], args.length === 1 ? MAMode.SMA : args[1]);
            case iBands:
                return args.length === 2
                    ? new IBands(args[0], MAMode.SMA, args[1], 0)
                    : new IBands(args[0], args[1], args[2], args[3]);
            case iBandsEx:
                return args.length === 4
                    ? new IBandsEx(args[0], MAMode.SMA, args[1], args[2], args[3])
                    : new IBandsEx(args[0], args[1], args[2], args[3], args[4]);
            case iBearsPower:
                return new IBearsPower(args[0], args[1]);
            case iBullsPower:
                return new IBullsPower(args[0], args[1]);
            case iBWMFI:
                return new IBWMFI();
            // добавочный агумент int maMode
            case iCCI:
                return args.length === 1 ? new ICCI(args[0], MAMode.SMA) : new ICCI(args[0], args[1]);
            // Добавочный аргумент int maMode
            case iCCIEx:
                return args.length === 2
                    ? new ICCIEx(args[0], MAMode.SMA, args[1])
                    : new ICCIEx(args[0], args[2], args[1]);
            case iDeMarker:
                return new IDeMarker(args[0]);
            case iEnvelopes:
                return args.length === 4
                    ? new IEnvelopes(args[0], args[1], 0, args[2], args[3])
                    : new IEnvelopes(args[0], args[1], args[2], args[3], args[4]);
            case iForce:
                return new IForce(args[0], args[1], args[2]);
            case iFractals:
                return new IFractals();
            case iGator:
                return new IGator(args[0], args[1], args[2], args[3], args[4], args[5], args[6], args[7]);
            case iIchimoku:
                return new IIchimoku(args[0], args[1], args[2]);
            case iMA:
                return new IMA(args[0], args[1]);
            case iMAEx:
                return new IMAEx(args[0], args[1], args[2], args[3], args[4]);
            case iMACD:
                return new IMACD(args[0], args[1], args[2]);
            case iMACDEx:
                return new IMACDEx(args[0], args[1], args[2], args[3]);
            case iMFI:
                return new IMFI(args[0]);
            case iMom:
                return new IMom(args[0]);
            case iMomEx:
                return new IMomEx(args[0], args[1]);
            case iOBV:
                return new IOBV(args[0]);
            case iOsMA:
                return new IOsMA(args[0], args[1], args[2], args[3]);
            // // Дополнительные три параметра - int maMode, int maPeriod, int rsiMethod
            // case  iRSI:
            //     // Е. Бабаев: #63476 - в конструктор мы таки передаем method
            //     return args.length === 1
            //         ? new IRSI(args[0], iBuildInIndicator.MODE_RSI_SIMPLE)
            //         : new IRSI(args[0], args[1])
            // // дополнительынй параметр rsi_mode
            // case  iRSIEx:
            //     // может лажать, порефакторил, проверь число параметров!
            //     return new IRSIEx(args[0], args[1], args[2])
            // дополнитеьный параметр int maMode
            case iRVI:
                return args.length === 1 ? new IRVI(args[0], MAMode.SMA) : new IRVI(args[0], args[1]);
            // дополнительынй параметр
            case iSAR:
                return args.length === 1 ? new ISAR(args[0], 0.2) : new ISAR(args[0], args[1]);
            case iStdDev:
                return args.length === 4
                    ? new IStdDev(args[0], args[1], args[2], args[3])
                    : new IStdDev(args[0], args[1], args[2], PriceType.Close);
            case iStdDevEx:
                return args.Length === 4
                    ? new IStdDevEx(args[0], args[1], args[2], args[3])
                    : new IStdDevEx(args[0], args[1], args[2], PriceType.Close);
            case iSTO:
                return args.length === 4
                    ? new ISTO(args[0], args[1], args[2], args[3], 0)
                    : new ISTO(args[0], args[1], args[2], args[3], args[4]);
            case iWPR:
                return new IWPR(args[0]);
        }
    }
}
export const iBuildInIndicatorFactory = new _iBuildInIndicatorFactory();
